import {useState} from 'react';
import {useHistory} from 'react-router-dom';

import {validate} from '../_helpers/form';
import {Field, Form as FormType} from '../types';
import {FormState} from '../components/Form';
import {Flow, FlowFetchResponse} from '../_services/Flow';

/**
 * Simple hook for saving a new entry. Provides save status, error messages and confirmation message
 * Note: This hook assumes you are using react-router and will if the form is configured to route to a particular
 * path (i.e. /entry on save as draft) this hook will handle that
 * Note: If passed a ref to a dom element (formSubmitErrorMessageRef) on error this hook will auto scroll to that element
 */
export const useSaveNewEntry = (
    form: FormType,
    formState: FormState,
    setFormState: any,
    formSubmitErrorMessageRef: any
) => {
    const history = useHistory<any>();
    const [confirmationMessage, setConfirmationMessage] = useState<string>('');
    const [formIsSubmitting, setFormIsSubmitting] = useState<boolean>(false);
    const [formSubmitErrorMessage, setFormSubmitErrorMessage] = useState<string>('');
    const [formShowConfirmation, setFormShowConfirmtaion] = useState<boolean>(false);

    const scrollToRef = (ref: any) => {
        if (ref?.current) {
            window.scrollTo({top: ref.current.offsetTop});
        }
    };

    console.log('useSaveNewEntry ', formState);

    const saveEntry = (saveAsDraft: boolean) => {
        setFormIsSubmitting(true);
        setFormSubmitErrorMessage('');

        if (!saveAsDraft && !validate(form, formState, setFormState)) {
            // scroll to first field with validation error
            form.fields.some((field: Field) => {
                const fieldName = field.name;
                if (formState.fieldState.hasOwnProperty(fieldName) && formState.fieldState[fieldName].invalid === true) {
                    setFormState((state: FormState) => ({
                        ...state,
                        fieldState: {
                            ...state.fieldState,
                            [fieldName]: {
                                ...state.fieldState[fieldName],
                                scrollTo: true
                            }
                        }
                    }));
                    return true;
                }
                return false;
            });
            setFormIsSubmitting(false);
            return;
        }

        const fieldValues = formState.fieldValues;
        if (saveAsDraft) {
            fieldValues.__should_save_draft = true;
        }

        Flow.getInstance().save(form.id, fieldValues)
            .then((response: FlowFetchResponse) => {
                if (response.ok && response.json) {
                    if (saveAsDraft) {
                        history.push('/entry/' + response.json.entry.id);
                    } else {
                        setFormShowConfirmtaion(true);
                        setConfirmationMessage(response.json.message);
                    }
                    window.scrollTo({top: 0});
                } else {
                    setFormSubmitErrorMessage(response.json.message || 'Error saving');
                    scrollToRef(formSubmitErrorMessageRef);
                }
                setFormIsSubmitting(false);
            })
            .catch((error: any) => {
                setFormSubmitErrorMessage(error || 'Error saving');
                setFormIsSubmitting(false);
                scrollToRef(formSubmitErrorMessageRef);
            });
    };

    return {
        saveEntry,
        confirmationMessage,
        formIsSubmitting,
        formSubmitErrorMessage,
        formShowConfirmation
    }
}